'<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :src="barImage"
    mobile-breakpoint="960"
    app
    mini-variant-width="80"
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props"/>
    </template>
    <div style="padding-top: 12px; text-align: right;">
      <img
          :width="65"
          :height="15"
          class="mr-2"
          src="../../assets/logo.png"/>
    </div>
    <v-divider class="mb-1"/>

    <v-list dense nav>
      <base-item class="item-sidebar" :item="profile"/>
    </v-list>

    <v-divider class="mb-2"/>

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>

      <template v-for="(item, i) in computedItems">
        <!-- -->
        <template >
          <base-item-group :class="selection === item.title ? 'custome-active' : ''" class="item-sidebar" v-if="item.children && showInSidebar(item.roles)" :key="`group-${i}`"
                           :item="item">
            <!--  -->
          </base-item-group>

          <base-item :class="selection === item.title ? 'custome-active' : ''" v-else-if="showInSidebar(item.roles)" :key="`item-${i}`" :item="item"/>
        </template>
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

// Utilities
import { mapState } from 'vuex';
import store from '@/store';
import _ from 'lodash';
import TokenService from '../../helpers/token';
import {
  CARE_ROUTER,
  CARE_ROUTER_BLENDED,
  DUO_ROUTER, TICKET_ROUTER,
  TYPE_CURRICULUM_OBJ,
} from '../../helpers/constant';
// eslint-disable-next-line import/named
import {
  permissionCheckMenuBlended,
  permissionCheckMenuBlendedSecondary,
} from '../../modules/blended/const';

export default {
  name: 'DashboardCoreDrawer',
  data: () => ({
    itemsMenuOnline: [
      {
        to: '/',
        icon: 'mdi-account',
        title: 'Gia sư Tiểu học',
        roles: ['tutor-homeroom-teacher_read', 'care-call_read', 'care-sale_read'],
        group: '',
        children: [
          {
            to: 'student-care?typeCurriculum=online&tutorSchoolLevel=primary',
            icon: 'mdi-account-tie',
            title: 'Chăm sóc học viên',
            roles: [
              'care-sale_read',
              'tutor-homeroom-teacher_read',
            ],
          },
          {
            to: 'contact-status?typeCurriculum=online&tutorSchoolLevel=primary',
            icon: 'mdi-phone',
            title: 'Cấu hình cuộc gọi',
            roles: ['care-call_read'],
          },
        ],
      },
      // {
      //   to: '/',
      //   icon: 'mdi-account-tie',
      //   title: 'DANH SÁCH HỌC VIÊN',
      //   roles: ['tutor-homeroom-teacher_read', 'care-call_read', 'care-sale_read'],
      //   group: '',
      //   children: [
      //     {
      //       to: 'blended-care',
      //       icon: 'mdi-account-tie',
      //       title: 'Blended Tutor',
      //       roles: [
      //         'care-sale_read',
      //         'tutor-homeroom-teacher_read',
      //       ],
      //     },
      //     {
      //       to: 'contact-list',
      //       icon: 'mdi-phone',
      //       title: 'Blended VHS',
      //       roles: ['care-call_read'],
      //     },
      //   ],
      // },
    ],
    expandOnHover: true,
    itemsMenuOnlineC2: [
      {
        to: '/',
        icon: 'mdi-account-tie',
        title: 'Gia sư THCS',
        roles: ['periodic-tab-secondary_read', 'extends-tab-secondary_read', 'move-sale-tab-secondary_read', 'special-care-tutor-secondary_read', 'tutor-student-detail-secondary_read', 'tutor-task-tab-secondary_read'],
        group: '',
        children: [
          {
            to: 'student-care?typeCurriculum=online&tutorSchoolLevel=secondary',
            icon: 'mdi-account-tie',
            title: 'Chăm sóc học viên',
            roles: [
              'care-sale-secondary_read',
              'tutor-homeroom-teacher-secondary_read',
              'periodic-tab-secondary_read',
              'extends-tab-secondary_read',
              'move-sale-tab-secondary_read',
              'special-care-tutor-secondary_read',
              'tutor-student-detail-secondary_read',
              'tutor-task-tab-secondary_read',
            ],
          },
          {
            to: 'contact-status?typeCurriculum=online&tutorSchoolLevel=secondary',
            icon: 'mdi-phone',
            title: 'Cấu hình cuộc gọi',
            roles: ['care-call-secondary_read'],
          },
        ],
      },
    ],
    itemsMenuIeltsy: [
      {
        to: '/',
        icon: 'mdi-school',
        title: 'STATION',
        roles: ['tutor-homeroom-teacher-ieltsy_read', 'care-call-ieltsy_read', 'care-sale-ieltsy_read'],
        group: '',
        children: [
          {
            to: 'student-care?typeCurriculum=ieltsy',
            icon: 'mdi-account-tie',
            title: 'Chăm sóc học viên',
            roles: [
              'care-sale-ieltsy_read',
              'tutor-homeroom-teacher-ieltsy_read',
            ],
          },
          {
            to: 'contact-status?typeCurriculum=ieltsy',
            icon: 'mdi-phone',
            title: 'Cấu hình cuộc gọi',
            roles: ['care-call-ieltsy_read'],
          },
        ],
      },
    ],
    itemMenuDuo: [
      {
        to: '/',
        icon: 'mdi-account-supervisor',
        title: 'DUO',
        roles: 'all',
        group: '',
        children: [
          {
            to: 'duo-care/list?typeCurriculum=duo&tab=0',
            icon: 'mdi-account-tie',
            title: 'Chăm sóc học viên',
            roles: 'all',
          },
          {
            to: 'contact-status?typeCurriculum=duo',
            icon: 'mdi-phone',
            title: 'Cấu hình cuộc gọi',
            roles: ['periodic-care_read', 'extend_read'],
          },
        ],
      },
    ],
    itemMenuBlendedTutor: [
      {
        to: '/',
        icon: 'mdi-account-group',
        title: 'BLENDED TUTOR',
        roles: [
          ...permissionCheckMenuBlended,
          ...permissionCheckMenuBlendedSecondary,
        ],
        group: '',
        children: [
          {
            to: 'blended-care?typeCurriculum=online&schoolLevel=primary',
            icon: 'mdi-account-tie',
            title: 'Gia sư Tiểu học',
            roles: permissionCheckMenuBlended,
          },
          {
            to: 'blended-care?typeCurriculum=online&schoolLevel=secondary',
            icon: 'mdi-account-tie',
            title: 'Gia sư THCS',
            roles: permissionCheckMenuBlendedSecondary,
          },
        ],
      },
    ],
    itemMenuTicket: [
      {
        to: '/ticket',
        icon: 'mdi-face-agent',
        title: 'HỖ TRỢ CSKH',
        roles: 'all',
      },
    ],
    items: [],
    routerFullPath: [
      {
        title: 'Gia sư Tiểu học',
        routeNames: [
          ...CARE_ROUTER,
          'ContactStatus',
        ],
        query: {
          typeCurriculum: 'online',
          tutorSchoolLevel: 'primary',
        },
      },
      {
        title: 'Gia sư THCS',
        routeNames: [
          ...CARE_ROUTER,
          'ContactStatus',
        ],
        query: {
          typeCurriculum: 'online',
          tutorSchoolLevel: 'secondary',
        },
      },
      {
        title: 'STATION',
        routeNames: [
          ...CARE_ROUTER,
          'ContactStatus',
        ],
        query: {
          typeCurriculum: 'ieltsy',
        },
      },
      {
        title: 'DUO',
        routeNames: [
          ...DUO_ROUTER,
          'ContactStatus',
        ],
        query: {
          typeCurriculum: 'duo',
        },
      },
      {
        title: 'BLENDED TUTOR',
        routeNames: [
          ...CARE_ROUTER_BLENDED,
          'StudentDetailBlended',
        ],
      },
      {
        title: 'Hỗ trợ CSKH',
        detailPath: '/ticket',
        routeNames: TICKET_ROUTER,
        listChildrenPath: ['/ticket'],
      },
    ],
    selection: 'STATION',
  }),

  created() {
    this.getItemMenu();
  },
  watch: {
    '$route.params': {
      handler() {
        this.routerFullPath.forEach((e) => {
          if (e.routeNames.includes(this.$route.name) && (e.query ? this.compareParamsObject(e.query, this.$route.query) : true)) {
            this.selection = e.title;
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        avatarPath: TokenService.getAvatarPath(),
        group: '',
        title: TokenService.getFullName(),
      };
    },
  },
  methods: {
    compareParamsObject(a, b) {
      if (typeof a === 'object') {
        // eslint-disable-next-line no-restricted-syntax
        for (const p in a) {
          // eslint-disable-next-line no-prototype-builtins
          if (a.hasOwnProperty(p)) {
            if (a[p] !== b[p]) return false;
          }
        }
      }
      return true;
    },
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: item.title,
      };
    },
    getItemMenu() {
      const typeCurriculumOrigin = _.cloneDeep(store.state.typeCurriculumOrigin);
      if (typeCurriculumOrigin.includes(TYPE_CURRICULUM_OBJ.ONLINE)) {
        this.items.push(...this.itemsMenuOnline);
      }
      this.items.push(...this.itemsMenuOnlineC2);
      if (typeCurriculumOrigin.includes(TYPE_CURRICULUM_OBJ.IELTSY)) {
        this.items.push(...this.itemsMenuIeltsy);
      }
      if (typeCurriculumOrigin.includes(TYPE_CURRICULUM_OBJ.DUO)) {
        this.items.push(...this.itemMenuDuo);
      }
      this.items.push(...this.itemMenuBlendedTutor);
      if (this.checkAuthorization('care-ticket-list_read')) {
        this.items.push(...this.itemMenuTicket);
      }
    },
    showInSidebar(roles) {
      if (roles === 'all') {
        return true;
      }
      const userPermissions = TokenService.getPermissions();
      const { permissions } = store.state;

      if (_.intersection(roles, userPermissions).length
        || _.intersection(roles, permissions).length) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style lang="scss">
.custome-active {
  .v-list-group__header {
    background-color: #6c6c6c !important;
  }
}
.custome-active.v-list-item--link {
  background: #1976d2 !important;
}
</style>
<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

    .v-navigation-drawer__content
      overflow-y: hidden

  &.v-navigation-drawer--is-mouseover
    .v-navigation-drawer__content
      overflow-y: auto

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px

  .item-sidebar .v-list-group__items .v-list-item__icon--text
    visibility: hidden !important
</style>
